<template>
  <div class="password-verifier">
    <div class="password-verifier__item">
      <CheckBox class="password-verifier__checkbox" validity :isSelected="hasNumber" />
      <span :class="['password-verifier__detail', hasNumber && 'password-verifier__detail--valid']"
        >One number</span
      >
    </div>
    <div class="password-verifier__item">
      <CheckBox class="password-verifier__checkbox" validity :isSelected="hasUppercase" />
      <span
        :class="['password-verifier__detail', hasUppercase && 'password-verifier__detail--valid']"
        >One uppercase letter</span
      >
    </div>
    <div class="password-verifier__item">
      <CheckBox class="password-verifier__checkbox" validity :isSelected="hasLowercase" />
      <span
        :class="['password-verifier__detail', hasLowercase && 'password-verifier__detail--valid']"
        >One lowercase letter</span
      >
    </div>
    <div class="password-verifier__item">
      <CheckBox class="password-verifier__checkbox" validity :isSelected="hasLength" />
      <span :class="['password-verifier__detail', hasLength && 'password-verifier__detail--valid']"
        >Eight characters in length</span
      >
    </div>
    <div class="password-verifier__item">
      <CheckBox class="password-verifier__checkbox" validity :isSelected="isPasswordConfirmed" />
      <span
        :class="[
          'password-verifier__detail',
          isPasswordConfirmed && 'password-verifier__detail--valid',
        ]"
        >Password is confirmed</span
      >
    </div>
  </div>
</template>

<script>
import CheckBox from '@/components/shared/CheckBox.vue'
import {
  passwordHasLowercase,
  passwordHasUppercase,
  passwordHasANumber,
  passwordHasCorrectLength,
} from '@/helpers/isPasswordValid'

export default {
  name: 'PasswordVerifierWidget',
  components: {
    CheckBox,
  },
  props: {
    password: {
      type: String,
      required: true,
    },
    isPasswordConfirmed: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    hasLowercase() {
      return passwordHasLowercase(this.password)
    },
    hasNumber() {
      return passwordHasANumber(this.password)
    },
    hasUppercase() {
      return passwordHasUppercase(this.password)
    },
    hasLength() {
      return passwordHasCorrectLength({ value: this.password, requiredLength: 8 })
    },
  },
}
</script>

<style lang="scss">
.password-verifier {
  color: var(--white);
  font-family: var(--font-regular);
  padding: 5px 0 15px 10px;
  @include mobile {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  &__item {
    width: 100%;
    @include tablet {
      width: 50%;
    }
    display: flex;
    align-items: center;
    margin: 5px 0px 5px 0;
    height: 20px;
    white-space: nowrap;
  }
  &__detail {
    margin: 0;
    padding: 0;
    font-size: rem(14);
    line-height: 20px;
    color: var(--light-blue-gray);
    &--valid {
      color: var(--white);
    }
  }
  &__checkbox {
    margin: 0 10px 0 0;
  }
}
</style>
